<template>
  <m-feature-enable-switch feature="goals" />
</template>

<script lang="ts">
import Vue from 'vue';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-goals',
  components: { MFeatureEnableSwitch },
});
</script>
